import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  containerBox: { textAlign: 'center', marginTop: theme.spacing(-5) },
  contentBody: {
    backgroundColor: '#fff',
    flexGrow: 1,
    padding: 16,
    position: 'relative',
  },
  floatBtn: {
    float: 'right',
  },
  socialBox: {
    margin: 'auto',
    justifyContent: 'space-around',
    '& a': {
      color: '#65a6ff',
      marginRight: 25,
    },
  },
  userImg: {
    width: 178,
    height: 178,
    objectFit: 'cover',
    margin: 'auto',
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    '& > img': {
      borderRadius: 8,
    },
  },
  [theme.breakpoints.up('md')]: {
    socialBox: {
      margin: 'unset',
      justifyContent: 'flex-start',
      '& a': {
        marginRight: 40,
      },
    },
    contentBody: {
      minHeight: '190px',
    },
    userImg: {
      width: 294,
      height: 263,
      margin: 'unset',
      padding: theme.spacing(3),
    },
    containerBox: {
      textAlign: 'left',
      alignItems: 'flex-end',
      marginTop: theme.spacing(-9),
    },
  },
}));

export default style;
